import type { DocumentReference, Timestamp } from 'firebase/firestore'
import { collection, query, where } from 'firebase/firestore'
import { firestore } from '~/firebaseCore'
import { PAYMENT_METHODS_SUBSIDY } from '~/store/orders'

export const collectionOrders = collection(
  firestore,
  'orders',
)

export function ordersDate(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp, route: DocumentReference) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'route',
      '==',
      route,
    ),
    where(
      'date',
      '>=',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function ordersSubsidy(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp, supplierRef: DocumentReference) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'paymentMethod',
      'in',
      PAYMENT_METHODS_SUBSIDY,
    ),
    where(
      'completementStatus',
      '==',
      'completed',
    ),
    where(
      'supplier',
      '==',
      supplierRef,
    ),
    where(
      'date',
      '>',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function ordersOnlinePayment(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'paymentStatus',
      'in',
      [
        'success',
        'partialRefund',
      ],
    ),
    where(
      'date',
      '>',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function ordersSalesPercentage(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp, data: number[]) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'completementStatus',
      '==',
      'completed',
    ),
    where(
      'salesPercentage',
      'in',
      data,
    ),
    where(
      'date',
      '>',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function ordersCompletedDateRange(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'completementStatus',
      '==',
      'completed',
    ),
    where(
      'date',
      '>',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function ordersFixedSales(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'completementStatus',
      '==',
      'completed',
    ),
    where(
      'isSales',
      '==',
      true,
    ),
    where(
      'date',
      '>',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function ordersSalesPercentageSecond(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'completementStatus',
      '==',
      'completed',
    ),
    where(
      'salesPercentage',
      'in',
      [
        0.5,
        0.55,
        0.6,
        0.65,
        0.7,
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
      ],
    ),
    where(
      'date',
      '>',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function ordersLoyaltyProgram(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'completementStatus',
      '==',
      'completed',
    ),
    where(
      'isLoyaltyProgram',
      '==',
      true,
    ),
    where(
      'date',
      '>',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function ordersIsNewUser(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'completementStatus',
      '==',
      'completed',
    ),
    where(
      'orderByRecommendation.isNewUser',
      '==',
      true,
    ),
    where(
      'date',
      '>',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function ordersToUpdate(company: DocumentReference, reference: DocumentReference) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'route',
      '==',
      reference,
    ),
    where(
      'progress',
      '==',
      'processing',
    ),
  )
}

export function ordersStatistic(company: DocumentReference, dateStart: Timestamp, dateEnd: Timestamp) {
  return query(
    collectionOrders,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'completementStatus',
      'in',
      [
        'completed',
        'waitingFirmAccept',
        'waitingCustomerAccept',
      ],
    ),
    where(
      'date',
      '>=',
      dateStart,
    ),
    where(
      'date',
      '<',
      dateEnd,
    ),
  )
}

export function currentOrdersRef(reference: DocumentReference, company: DocumentReference) {
  return query(
    collectionOrders,
    where(
      'supplier',
      '==',
      reference,
    ),
    where(
      'company',
      '==',
      company,
    ),
    where(
      'progress',
      '==',
      'processing',
    ),
  )
}
